import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { formatPrettyDate } from '../utils';
import moment from 'moment';
var Event = function Event(props) {
  var _nycjwEvent$dates5;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageVisible = _useState2[0],
    setImageVisible = _useState2[1];
  var imageRef = useRef(null);
  useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setImageVisible(true);
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '100px'
    });
    if (imageRef.current) {
      observer.observe(imageRef.current);
    }
    return function () {
      return observer.disconnect();
    };
  }, []);
  var eventType = props.eventType,
    nycjwEvent = props.nycjwEvent;
  var eventEndTime = nycjwEvent.end_time ? moment(nycjwEvent.end_time, ["h:mm A"]).format("HH:mm:ss") : moment('23:59:59', ["h:mm A"]).format("HH:mm:ss");
  var navigate = useNavigate();
  var params = useParams();
  var selectedTestDay = useSelector(function (state) {
    return state.selectedTestDay;
  });
  var todaysDate = useSelector(function (state) {
    return state.todaysDate;
  });
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    dateActive = _useState4[0],
    setDateActive = _useState4[1];
  var _useState5 = useState(eventType === 'virtual' ? 'Learn More' : 'RSVP'),
    _useState6 = _slicedToArray(_useState5, 2),
    buttonLabel = _useState6[0],
    setButtonlabel = _useState6[1];
  var _useState7 = useState(new Date()),
    _useState8 = _slicedToArray(_useState7, 2),
    today = _useState8[0],
    setToday = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showDates = _useState10[0],
    setShowDates = _useState10[1];
  var toggleShowDates = function toggleShowDates() {
    setShowDates(!showDates);
  };

  // console.log('event dates', nycjwEvent.dates)

  var EventDates = function EventDates() {
    if (nycjwEvent.dates.length) {
      if (nycjwEvent.dates.length > 1) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem'
          },
          onClick: toggleShowDates
        }, /*#__PURE__*/React.createElement("p", {
          style: {
            margin: 0,
            fontFamily: 'Bebas Neue'
          }
        }, "Event Dates"), /*#__PURE__*/React.createElement("svg", {
          style: {
            transform: "scale(".concat(showDates ? '1, -1' : 1, ")")
          },
          width: "12",
          height: "6",
          viewBox: "0 0 14 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.645917 0.645917C0.692363 0.599354 0.747539 0.562411 0.808284 0.537204C0.869029 0.511998 0.93415 0.499023 0.999917 0.499023C1.06568 0.499023 1.13081 0.511998 1.19155 0.537204C1.2523 0.562411 1.30747 0.599354 1.35392 0.645917L6.99992 6.29292L12.6459 0.645917C12.6924 0.599429 12.7476 0.562553 12.8083 0.537394C12.8691 0.512234 12.9342 0.499285 12.9999 0.499285C13.0657 0.499285 13.1308 0.512234 13.1915 0.537394C13.2522 0.562553 13.3074 0.599429 13.3539 0.645917C13.4004 0.692405 13.4373 0.747594 13.4624 0.808333C13.4876 0.869073 13.5005 0.934173 13.5005 0.999917C13.5005 1.06566 13.4876 1.13076 13.4624 1.1915C13.4373 1.25224 13.4004 1.30743 13.3539 1.35392L7.35392 7.35392C7.30747 7.40048 7.2523 7.43742 7.19155 7.46263C7.13081 7.48784 7.06568 7.50081 6.99992 7.50081C6.93415 7.50081 6.86903 7.48784 6.80828 7.46263C6.74754 7.43742 6.69236 7.40048 6.64592 7.35392L0.645917 1.35392C0.599354 1.30747 0.562411 1.2523 0.537205 1.19155C0.511998 1.13081 0.499023 1.06568 0.499023 0.999917C0.499023 0.93415 0.511998 0.869028 0.537205 0.808283C0.562411 0.747538 0.599354 0.692363 0.645917 0.645917Z",
          fill: "black"
        }))), showDates && /*#__PURE__*/React.createElement("div", null, nycjwEvent.dates.map(function (date, i) {
          return /*#__PURE__*/React.createElement("div", {
            key: "date".concat(i)
          }, formatPrettyDate(date));
        })));
      } else {
        return formatPrettyDate(nycjwEvent.dates[0]);
      }
    }
  };
  var curEventType = eventType ? eventType : 'scheduled';
  var weekEndDate = new Date(eventIntros[eventIntros.length - 1]);
  weekEndDate.setDate(weekEndDate.getDate() + 1);
  useEffect(function () {
    if (selectedTestDay !== null) {
      setToday(new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())));
    }
  }, [selectedTestDay, todaysDate]);
  useEffect(function () {
    setToday(selectedTestDay ? new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())) : new Date());
  }, [nycjwEvent]);
  useEffect(function () {
    var _nycjwEvent$dates, _nycjwEvent$dates2, _nycjwEvent$dates3, _nycjwEvent$dates4;
    var eventStartDate = (_nycjwEvent$dates = nycjwEvent.dates) !== null && _nycjwEvent$dates !== void 0 && _nycjwEvent$dates.length ? new Date(nycjwEvent.dates[0].date + 'T09:00:00') : null;
    var eventEndDate = (_nycjwEvent$dates2 = nycjwEvent.dates) !== null && _nycjwEvent$dates2 !== void 0 && _nycjwEvent$dates2.length ? new Date(nycjwEvent.dates[nycjwEvent.dates.length - 1].date + 'T' + nycjwEvent.dates[nycjwEvent.dates.length - 1].end_time) : null;
    var dateActiveText = today > eventStartDate ? 'event-active' : '';
    var buttonLabelText = buttonLabel;
    var ongoingStartTime = (_nycjwEvent$dates3 = nycjwEvent.dates) !== null && _nycjwEvent$dates3 !== void 0 && _nycjwEvent$dates3.length ? moment(nycjwEvent.dates[0].start_time, ["h:mm A"]).format("HH:mm:ss") : moment('07:00:00', ["h:mm A"]).format("HH:mm:ss");
    var eventDate = (_nycjwEvent$dates4 = nycjwEvent.dates) !== null && _nycjwEvent$dates4 !== void 0 && _nycjwEvent$dates4.length ? new Date(nycjwEvent.dates[0].date + 'T' + ongoingStartTime) : null;
    if (curEventType === 'one-time') {
      dateActiveText = '';
      if (today >= eventDate) {
        buttonLabelText = 'Learn More';
      } else {
        buttonLabelText = nycjwEvent.listing_button_label ? nycjwEvent.listing_button_label : 'RSVP';
        if (!nycjwEvent.rsvp) {}
      }
    }
    if (today < eventDate && nycjwEvent.listing_button_label) {
      buttonLabelText = nycjwEvent.listing_button_label;
    }
    if (curEventType === 'on-going' || curEventType === 'virtual') {
      dateActiveText = '';
      if (nycjwEvent.start_date && nycjwEvent.start_date !== 'Invalid Date' || nycjwEvent.date) {
        var eventStartTime = nycjwEvent.start_time ? nycjwEvent.start_time : '06:00:00';
        eventStartDate = nycjwEvent.start_date ? new Date(nycjwEvent.start_date + 'T' + eventStartTime) : new Date(nycjwEvent.date + 'T' + eventStartTime);
        var _eventEndTime = nycjwEvent.end_time ? nycjwEvent.end_time : '11:59:00';
        eventEndDate = nycjwEvent.end_date ? new Date(nycjwEvent.end_date + 'T' + _eventEndTime) : new Date(nycjwEvent.start_date + 'T' + _eventEndTime);
      }
      if (nycjwEvent.dates) {
        var _eventStartTime = nycjwEvent.dates[0].start_time || '06:00:00';
        eventStartDate = new Date(nycjwEvent.dates[0].event_date + 'T' + _eventStartTime);
        var _eventEndTime2 = nycjwEvent.dates[nycjwEvent.dates.length - 1].end_time || '11:59:00';
        eventEndDate = new Date(nycjwEvent.dates[nycjwEvent.dates.length - 1].event_date + 'T' + _eventEndTime2);
      }
      if (curEventType === 'on-going') {
        if (today >= eventStartDate) {
          buttonLabelText = 'Learn More';
        } else {
          buttonLabelText = nycjwEvent.listing_button_label ? nycjwEvent.listing_button_label : 'Learn more';
        }
      }
      if (curEventType === 'virtual') {
        if (today >= eventStartDate) {
          buttonLabelText = 'Learn More';
        } else {
          buttonLabelText = 'Learn More';
        }
      }
    }

    // If todays date is after the event end date
    if (today > eventEndDate && today < weekEndDate && eventType !== 'virtual') {
      dateActiveText = ' event-over';
    }
    setDateActive(dateActiveText);
    setButtonlabel(buttonLabelText);
  }, [today]);
  var borderColor = nycjwEvent.event_types ? nycjwEvent.event_types[0].color ? nycjwEvent.event_types[0].color : '#FEF200' : '#FEF200';
  var eventTypeName = nycjwEvent.event_types ? nycjwEvent.event_types[0].name : null;
  var eventPermalink = useMemo(function () {
    // Type
    var eventTypeLink = curEventType;
    if (eventType === 'in-person') {
      eventTypeLink = nycjwEvent.date ? 'one-time' : 'on-going';
    }
    // Category
    var eventCat = nycjwEvent.date;
    if (!eventCat) {
      eventCat = nycjwEvent.event_types ? nycjwEvent.event_types[0].slug : null;
    }
    // Permalink
    var permalink = nycjwEvent.permalink.split('/');
    permalink = permalink[permalink.length - 1];
    var eventLink = nycjwEvent.supporting ? eventTypeLink === 'virtual' ? eventCat === 'instagram' ? "/".concat(eventTypeLink, "/instagram/").concat(permalink, "/").concat(nycjwEvent.supporting_permalink) : "/".concat(eventTypeLink, "/").concat(permalink, "/").concat(nycjwEvent.supporting_permalink) : "/".concat(eventTypeLink, "/").concat(eventCat, "/").concat(permalink, "/").concat(nycjwEvent.supporting_permalink) : eventTypeLink === 'virtual' ? eventCat === 'instagram' ? "/".concat(eventTypeLink, "/instagram/").concat(permalink) : "/".concat(eventTypeLink, "/").concat(permalink) : "/".concat(eventTypeLink, "/").concat(eventCat, "/").concat(permalink);
    return eventLink;
  }, [curEventType, params, nycjwEvent]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "event-listing ".concat(dateActive).concat(nycjwEvent.intro ? ' intro' : '', " ").concat(nycjwEvent.scheduled_or_durational)
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-image-wrapper",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return navigate({
        pathname: nycjwEvent.permalink
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-image-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-image bg-centered",
    ref: imageRef
  }, imageVisible && /*#__PURE__*/React.createElement("img", {
    src: nycjwEvent.listing_image,
    alt: "Event",
    style: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover'
    },
    loading: "lazy"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "event-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-title"
  }, !nycjwEvent.intro && /*#__PURE__*/React.createElement("p", {
    className: "event-type"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: 'black',
      color: 'white'
    }
  }, nycjwEvent.virtual ? 'Virtual' : 'In-person'), eventTypeName && /*#__PURE__*/React.createElement("span", {
    style: {
      background: borderColor,
      color: borderColor.toLowerCase() === '#fef200' || borderColor === 'rgb(255,255,0)' ? 'black' : 'white'
    }
  }, eventTypeName)), /*#__PURE__*/React.createElement("h4", {
    dangerouslySetInnerHTML: {
      __html: nycjwEvent.title
    },
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return navigate({
        pathname: nycjwEvent.permalink
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "event-time"
  }, ((_nycjwEvent$dates5 = nycjwEvent.dates) === null || _nycjwEvent$dates5 === void 0 ? void 0 : _nycjwEvent$dates5.length) && /*#__PURE__*/React.createElement(EventDates, null)), /*#__PURE__*/React.createElement("div", {
    className: "cta-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: function onClick() {
      return navigate({
        pathname: nycjwEvent.permalink
      });
    }
  }, buttonLabel))))));
};
export default Event;